
import EmailModalProvider from "app/context/EmailModalProvider";

interface IAppWrapper {
  children: React.ReactNode;
}

const AppWrapper: React.FC<IAppWrapper> = ({ children }) => {
  return (
    <EmailModalProvider>
      <div>{children}</div>
    </EmailModalProvider>
  );
};

export default AppWrapper;
